export const callPhoneNumberAction = async ({ commit }, payload) => {
  commit('callPhoneNumberMutator', payload)
}
export const dialPadStatusAction = async ({ commit }, payload) => {
  commit('dialPadStatusMutator', payload)
}
